import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {ChangeProfileDto, EditProfileDto} from "../models/profile.models";
import {UserInfoService} from "../../../services/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class ProfileDataService {

  agentId: string | undefined
  userId: number | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })
  }

  editProfile(data: EditProfileDto): Observable<void> {
    const url = `/agents/${this.agentId}/users/${this.userId}/profile`
    return this.apiService.httpPut<void>(url, data)
  }

  change2FA(isEnabled: boolean): Observable<void> {
    const url = `/agents/${this.agentId}/users/${this.userId}/profile/2fa?is_enabled=${isEnabled}`
    return this.apiService.httpPatch<void>(url)
  }

  changePassword(data: ChangeProfileDto): Observable<void> {
    const url = `/agents/${this.agentId}/users/${this.userId}/profile/update_password`
    return this.apiService.httpPatchGroup<void>(url, data)
  }
}
